





































import { Menu } from '@/services/Menus'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import _ from 'lodash'
@Component
export default class TemplateIndex extends Vue {

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Getter('components/menuSidebar')
  private menus!: Menu[]

  @Prop({default: ''}) private title: string

  private updated() {
    let title = this.title
    if (!title && this.$router.currentRoute.path.startsWith('/main')) {
      const findMenu = _.find(this.menus, {route: this.$route.params.page})
      title = findMenu ? findMenu.title : this.title
    }
    this.updateTitlePage(title)
  }
}
